import React, { PropTypes } from 'react';

let LoadingSpinner = function(props) {
	let className = 'loading-spinner fa fa-cog';

	// Spin by default.
	if (props.spin !== false) {
		className += ' fa-spin';
	}

	return (<i className={ className } />);
};

LoadingSpinner.propTypes = {
	spin: PropTypes.bool
};
LoadingSpinner.displayName = 'LoadingSpinner';

LoadingSpinner.displayName = 'LoadingSpinner';

module.exports = LoadingSpinner;



// WEBPACK FOOTER //
// ./frontend/shared/js/components/LoadingSpinner.jsx